import type { z } from 'zod'

interface PasswordConfirmationFields {
  readonly password?: string | null | undefined
  readonly password_confirmation?: string | null | undefined
}

export const refinePasswordConfirmation = (
  value: PasswordConfirmationFields,
  ctx: z.RefinementCtx
): void => {
  if (typeof value.password === 'string' && value.password !== value.password_confirmation) {
    ctx.addIssue({
      code: 'custom',
      message: 'The password field confirmation does not match',
      path: ['password']
    })
  }
}
